(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("DomoticalabsApi", [], factory);
	else if(typeof exports === 'object')
		exports["DomoticalabsApi"] = factory();
	else
		root["DomoticalabsApi"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition